import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { HeaderMetaNavModule } from '@hdms/shared/page-frame/ui';
import { ButtonModule, FlyoutModule, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { HeaderMetaPopoverComponent } from './header-meta-popover.component';

@NgModule({
  declarations: [HeaderMetaPopoverComponent],
  imports: [
    CommonModule,
    ButtonModule,
    FlyoutModule,
    SvgIconModule,
    NgbModalModule,
    HeaderMetaNavModule,
    AnalyticsModule
  ],
  exports: [HeaderMetaPopoverComponent]
})
export class HeaderUIMetaPopoverModule {}
